import { graphql } from 'react-relay';

export default graphql`
  query privateRouteQuery($packageId: Int) {
    packageTracker(packageId: $packageId) {
      packageInfo {
        trackingKey
        companyHash
      }
    }
  }
`;
